// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
  background: white;
  border-radius: 8px;
  padding: 32px 24px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.3s ease;
}
.error-modal .error-icon {
  height: 72px;
  width: 72px;
  margin-bottom: 8px;
}
.error-modal h2 {
  font-family: AppFontMedium;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 22px;
}
.error-modal .text {
  font-size: 18px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-wrap: balance;
  color: var(--color-black);
  margin-bottom: 20px;
}
.error-modal .price {
  margin-bottom: 25px;
}
.error-modal .order-price {
  font-size: 18px;
  margin-bottom: 5px;
}
.error-modal ion-button:first-of-type {
  margin-bottom: 8px;
}
.error-modal ion-button:last-child {
  --background: transparent;
  --border-color: var(--ion-color-secondary);
  --border-style: solid;
  --border-width: 1px;
  color: var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/recalculation-price-modal/recalculation-price-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AACD;AACC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AACF;AAEC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAFF;AAKC;EACC,mBAAA;AAHF;AAMC;EACC,eAAA;EACA,kBAAA;AAJF;AAQE;EACC,kBAAA;AANH;AAQE;EACC,yBAAA;EACA,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,iCAAA;AANH","sourcesContent":[".error-modal {\n\tbackground: white;\n\tborder-radius: 8px;\n\tpadding: 32px 24px;\n\twidth: 100%;\n\ttext-align: center;\n\tanimation: slideUp 0.3s ease;\n\n\t.error-icon {\n\t\theight: 72px;\n\t\twidth: 72px;\n\t\tmargin-bottom: 8px;\n\t}\n\n\th2 {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 24px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 22px;\n\t}\n\n\t.text {\n\t\tfont-size: 18px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\n\t\ttext-wrap: balance;\n\t\tcolor: var(--color-black);\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.price {\n\t\tmargin-bottom: 25px;\n\t}\n\n\t.order-price {\n\t\tfont-size: 18px;\n\t\tmargin-bottom: 5px;\n\t}\n\n\tion-button {\n\t\t&:first-of-type {\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\t\t&:last-child {\n\t\t\t--background: transparent;\n\t\t\t--border-color: var(--ion-color-secondary);\n\t\t\t--border-style: solid;\n\t\t\t--border-width: 1px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
